import React, { lazy } from "react";
import { Route } from "react-router";

import { RouteGuardApplicationRights } from "components/routes/RouteGuardApplicationRights";
import { LazyRouteElement } from "components/routes/LazyRouteElement";
import Layout from "components/layout/Layout";
import { Module } from "./Module";

const IndexLazy = lazy(() => import("./pages/Index").then(module => ({ default: module.Index })));

export function Routes() {
    return (
        <>
            <Route
                key="message-archive-index"
                path="/message-archive/"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<IndexLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            /> 
        </> 
    )
}
